import { ApiProperty } from "@nestjs/swagger";
import { BaseEntity, Column, Entity, Index, JoinColumn, JoinTable, ManyToMany, ManyToOne, OneToMany, OneToOne, PrimaryColumn, PrimaryGeneratedColumn, RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";
import { QaQcOperations } from "../qa-qc-operations/qa-qc-operations.entity";
import { WorkstationCategories } from "../workstation-category/workstation-category.entity";
// import { Address } from "./address.entity";

@Entity('operations')
export class Operations {

  @PrimaryGeneratedColumn("increment",{name:'operation_id'})
  operationId:number;
  @Column("varchar",{
    nullable:false,
    length:50,
    name:"operation_code"
    })
    operationCode:string;
  @Column("varchar",{
    nullable:false,
    length:100,
    name:"operation_name"
    })
    operationName:string;
  
  @Column("int",{
    nullable:false,
    name:"workstation_category_id"
    })
    workstationCategoryId:number;
    @Column("boolean",{
      nullable:false,
      default:false,
      name:"is_value_addition"
      })
    isValueAddition:boolean;

  @Column("boolean",{
    nullable:false,
    default:true,
    name:"is_active"
    })
  isActive:boolean;

  @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;

  @Column("varchar", {
      nullable: false,
      name: "created_user",
      default: "ADMIN",
      length:50
  })
  createdUser: string | null;


  @UpdateDateColumn({
      name: "updated_at",
      type:'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
      nullable: true,
      name: "updated_user",
      length:50
  })
  updatedUser: string | null;

  @VersionColumn({
      default:1,
      name: "version_flag"
  })

  versionFlag: number;

  
 
  @ManyToOne(type=>WorkstationCategories, workstationCategory=>workstationCategory.workstationInfo,{  nullable:false, })
  @JoinColumn({ name:"workstation_category_id"})
  workstationCategoryInfo: WorkstationCategories;
  
 
  @OneToMany(type => QaQcOperations, qaQc => qaQc.operationInfo)
  qaQcInfo: QaQcOperations[];


}
